import { createMetadataGroupKey } from "./chart/splitKeys"
import type { MetricValue } from "./chartShared"

export const normalizeTableMetricValues = ({
  agentNames,
  groupByMetadataKey,
  rows,
}: {
  agentNames?: Record<string, string>
  groupByMetadataKey?: string
  rows: Record<string, unknown>[]
}): MetricValue[] =>
  rows.map((row) => ({
    // Table rows share the broader MetricValue contract, which expects a number.
    // Empty cells are represented by missing rows/cells rather than a null row.value.
    value: row.value != null ? Number(row.value) : 0,
    count: row.count != null ? Number(row.count) : undefined,
    createdAt:
      typeof row.run_occurred_at === "string"
        ? row.run_occurred_at
        : new Date(0).toISOString(),
    metricId:
      typeof row.metric_id === "string"
        ? row.metric_id
        : typeof row.metricId === "string"
          ? row.metricId
          : "",
    metric_id:
      typeof row.metric_id === "string"
        ? row.metric_id
        : typeof row.metricId === "string"
          ? row.metricId
          : undefined,
    agentName:
      typeof row.run_agent_id === "string"
        ? agentNames?.[row.run_agent_id] || row.run_agent_id
        : undefined,
    assignee: typeof row.assignee === "string" ? row.assignee : undefined,
    metadataValue:
      groupByMetadataKey || typeof row.metadata_value === "string"
        ? createMetadataGroupKey({
            kind:
              row.metadata_group_kind === "remainder" ? "remainder" : "value",
            metadataKey: groupByMetadataKey,
            topValues: Array.isArray(row.metadata_top_values)
              ? row.metadata_top_values.filter(
                  (value): value is string => typeof value === "string",
                )
              : undefined,
            value:
              typeof row.metadata_value === "string"
                ? row.metadata_value
                : null,
          })
        : undefined,
    mutation_id:
      typeof row.mutation_id === "string" ? row.mutation_id : undefined,
    mutationName:
      typeof row.mutation_name === "string"
        ? row.mutation_name
        : typeof row.mutationName === "string"
          ? row.mutationName
          : undefined,
    personaName:
      typeof row.persona_name === "string"
        ? row.persona_name
        : typeof row.personaName === "string"
          ? row.personaName
          : undefined,
    persona_id: typeof row.persona_id === "string" ? row.persona_id : undefined,
    run_agent_id:
      typeof row.run_agent_id === "string" ? row.run_agent_id : undefined,
    run_template_name:
      typeof row.run_template_name === "string"
        ? row.run_template_name
        : undefined,
    templateName:
      typeof row.template_name === "string"
        ? row.template_name
        : typeof row.templateName === "string"
          ? row.templateName
          : undefined,
    simulationOutputCreatedAt:
      typeof row.run_occurred_at === "string" ? row.run_occurred_at : undefined,
    testSetName:
      typeof row.test_set_name === "string"
        ? row.test_set_name
        : typeof row.testSetName === "string"
          ? row.testSetName
          : undefined,
    test_set_id:
      typeof row.test_set_id === "string" ? row.test_set_id : undefined,
  }))
